import { Paper, Text, Table, Badge, Box } from "@mantine/core";

/**
 * Distribución de leads por país.
 * Muestra tabla con: país, total leads, en progreso, convertidos, perdidos, tasa de conversión.
 * Incluye barra visual de proporción.
 */
export default function CountryBreakdown({ countries }) {
    if (!countries || countries.length === 0) {
        return (
            <Paper shadow="sm" radius="md" p="lg">
                <Text fw={600} size="lg" mb="sm">
                    Distribución por país
                </Text>
                <Text size="sm" c="dimmed">
                    No hay datos de países para el período seleccionado.
                </Text>
            </Paper>
        );
    }

    const maxLeads = Math.max(...countries.map((c) => c.totalLeads), 1);

    return (
        <Paper shadow="sm" radius="md" p="lg" style={{ overflowX: "auto" }}>
            <Text fw={600} size="lg" mb="md">
                Distribución por país
            </Text>

            <Table striped highlightOnHover withTableBorder>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th>País</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Leads</Table.Th>
                        <Table.Th style={{ width: "30%" }}>Proporción</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>En prog.</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Conv.</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Perdidos</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Tasa conv.</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {countries.map((item) => {
                        const barWidth = (item.totalLeads / maxLeads) * 100;
                        return (
                            <Table.Tr key={item.country}>
                                <Table.Td>
                                    <Text size="sm" fw={500}>
                                        {item.country}
                                    </Text>
                                </Table.Td>
                                <Table.Td style={{ textAlign: "center" }}>
                                    <Text size="sm" fw={600}>{item.totalLeads}</Text>
                                </Table.Td>
                                <Table.Td>
                                    <Box
                                        style={{
                                            width: `${Math.max(barWidth, 3)}%`,
                                            height: 8,
                                            backgroundColor: "var(--mantine-color-blue-4)",
                                            borderRadius: 4,
                                            transition: "width 0.3s ease",
                                        }}
                                    />
                                </Table.Td>
                                <Table.Td style={{ textAlign: "center" }}>
                                    <Text size="sm" c="blue">{item.inProgress}</Text>
                                </Table.Td>
                                <Table.Td style={{ textAlign: "center" }}>
                                    <Text size="sm" c="green" fw={600}>{item.converted}</Text>
                                </Table.Td>
                                <Table.Td style={{ textAlign: "center" }}>
                                    <Text size="sm" c="red">{item.lost}</Text>
                                </Table.Td>
                                <Table.Td style={{ textAlign: "center" }}>
                                    <ConversionBadge rate={item.conversionRate} />
                                </Table.Td>
                            </Table.Tr>
                        );
                    })}
                </Table.Tbody>
            </Table>
        </Paper>
    );
}

function ConversionBadge({ rate }) {
    let color = "red";
    if (rate >= 20) color = "green";
    else if (rate >= 10) color = "yellow";

    return (
        <Badge variant="light" color={color} size="md">
            {rate}%
        </Badge>
    );
}
